<!-- 话题的列表项 -->
<template>
<div class="item">
    
    <div class="show-style">
        <div class="g-lf">
            <div class="user-cont">
                <div class="user-avatar"><YorkbbsImage :href="userHome|hostBuild('home')" target="_blank" :src="avatar" borderRadius="50%" width="36px" height="36px" /></div>
                <div class="flex-cont">
                    <div class="user-name"><a :href="userHome|hostBuild('home')" target="_blank">{{userName}}</a></div>
                    <div class="time">{{createdAt|timeToStr}}</div>
                </div>
                <div class="attention" :class="{active:isAttention}" @click="attention" v-loading="handleLoading">{{isAttention?'已关注':'关注'}}</div>
                
            </div>
            <div class="middle-content">
                <div class="post-title"><a :href="detailUrl|hostBuild('forum')" target="_blank">{{postTitle}}</a></div>
                <div class="imgs" v-if="videoPost == 0 && imgList.length>1" >
                    <div class="lit" v-for="(item,index) in imgList" :key="item+'_'+index" :class="{'grid-nine': [9,99].includes(imgType) ,'double-grid':(imgType == 99 && imgList.length<5 && (imgList.length%2 == 0))}">
                        <div class="box">
                            <YorkbbsImage :link="detailUrl|hostBuild('forum')" :src="item|webpFormat(375)" aspect animation  target="_blank"   />
                        </div>
                    </div>
                </div>
                <div class="only-one-img" v-if="videoPost == 0 &&  imgList.length == 1">
                    <!-- <YorkbbsImage class="sign-img-border"  :src="imgList[0]|webpFormat(750)" :link="detailUrl|hostBuild('forum')"  animation borderRadius="4px" target="_blank"   /> -->
                    <a :href="detailUrl|hostBuild('forum')" target="_blank">
                    
                        <img :src="imgList[0]|webpFormat(750)" alt="">
                    </a>
                </div>
                <div class="video-warp" v-if="videoPost !=0 && videoList.length >0 ">
                    <video controls>
                        <source :src="videoList[0]">
                    </video>
                </div>
            </div>
            <div class="desc">
                
                <div class="view-total"><i class="yk yk-home_view"></i> {{data.property.view}}</div>
                <div class="lit comment"><a :href="detailUrl|hostBuild('forum')" target="_blank"><i class="yk-information"></i> {{data.property.commentTotal?data.property.commentTotal:'回复'}}</a></div>
                <div class="lit admire" @click="thumbUp" :class="{clicked:data.property.hasGivenThumbUp}"><i class=" " :class="{'yk-liked':data.property.hasGivenThumbUp,'yk-like':!data.property.hasGivenThumbUp}"></i>{{data.property.hasGivenThumbUp?'已赞':'赞'}}</div>
            </div>
        </div>
       <!--  <div class="g-lr" v-if="imgList.length == 1"><YorkbbsImage class="sign-img-border"  :src="imgList[0]|webpFormat(750)" :link="detailUrl|hostBuild('forum')" aspect animation borderRadius="4px" target="_blank"   /></div> -->
    </div>
</div>    
</template>
<script>
export default {
    name:'SubjectPostItem',
    props:['data','imgType'],
    
    computed:{
        avatar(){
            return this.data.user.avatar;
        },
        userHome(){
            return `/home/${this.data.user.id}`;
        },
        userName(){
            return this.data.user.username;
        },
        createdAt(){
            return this.data.createdAt;
        },
        postTitle(){
            return this.data.title;
        },
        videoPost(){
            return  this.data.property.videoPost || 0;
        },
        videoList(){
            return this.data.videoList||[];
        },
        imgList(){
            //return ['https://media2.imgyb.xyz/media/v1/image/1b749ccee37f68180c63e22998af4671.png']
            let userNum = this.imgType == 99 ?9:this.imgType;
            return this.data.imageList.length>userNum?this.data.imageList.splice(0,userNum):this.data.imageList;
        },
        detailUrl(){
            return `/detail/${this.data.id}?topic=chat`
        },
        account(){
            return this.$store.getters.user;
        },
        isAttention(){
            return this.data.user.focusedByMe == 1;
        }

    },
    data(){
        return {
            thumbLoading:false,
            handleLoading:false,
        }
    },
    methods:{
        
        async thumbUp(){
            
            if( this.account.id == undefined){
                window.location.href = hostBuild(`/login?redirect=${window.location.href}`, 'account');
                return false;
            }
            if( this.thumbLoading ) return false;
            if( this.data.property.hasGivenThumbUp == 0 ){
                let result = await this.$axios.post('/bbs/v1/give/thumb/up/to/post',{ownerId:this.data.id});
                if( result.code == 0 ){
                    this.$success('点赞成功!');
                    this.data.property.hasGivenThumbUp = 1;
                    this.data.property.thumbUpTotal +=1;
                }
                
            }else{
                let result = await this.$axios.post('/bbs/v1/drop/thumb/up/from/post',{ownerId:this.data.id});
                if( result.code == 0 ){
                    this.$success('取消点赞成功!');
                    this.data.property.hasGivenThumbUp = 0;
                    this.data.property.thumbUpTotal -=1;
                }
            }
            this.thumbLoading = false;
        },
        //关注
        async attention(){
            if( this.account.id == undefined){
                window.location.href = hostBuild(`/login?redirect=${window.location.href}`, 'account');
                return false;
            }
            if( this.handleLoading ) return false;
            this.handleLoading = true;
            if(this.isAttention){
                //已关注
                let result = await this.$axios.post('/user/v1/remove/attention/from',{toUserId:this.data.user.id});
                if( result.code == 0 ){
                    this.$success('取消关注成功');
                    //this.data.user.focusedByMe = 0;
                    this.$emit('attention',{id:this.data.user.id,val:0})
                }
            }else{
                let result = await this.$axios.post('/user/v1/pay/attention/to',{toUserId:this.data.user.id});
                if( result.code == 0 ){
                    this.$success('关注成功');
                    //this.data.user.focusedByMe = 1;
                    this.$emit('attention',{id:this.data.user.id,val:1})
                }
            }
            this.handleLoading = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.item{
    margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #eee; 
    .user-cont{
        display: flex; align-items: center; margin-bottom: 10px;
        .user-avatar{margin-right: 10px;}
        .user-name{font-size: 14px; color: #111; line-height: 22px; font-weight: bold;}
        .time{font-size: 12px; line-height: 18px; color: #999;}
        .attention{
            font-size: 12px; height: 28px; padding: 0 15px; color: #333; border:1px solid rgba(238,238,238,0.70); border-radius: 4px;
            display: flex; align-items: center; user-select: none; cursor: pointer; position: relative;
            &:hover{background: #fcebeb; color: #e43a3a;border-color: #fcebeb;}
            &.active{
                border-color: #f8f8f8; background: #f8f8f8;
            }
        }
    }
    .post-title{font-size: 16px; line-height: 24px; margin-bottom: 10px;}
    .imgs{
        display: flex; margin: 0 -5px 0; flex-wrap: wrap;
        .lit{
            width:25%; padding: 0 5px; box-sizing: border-box; margin-bottom: 10px;
            .box{border:1px solid #eee; border-radius: 4px; overflow: hidden;}
            
            &.alone{
                .lit{width:80%;}
            }
            &.double{
                .lit{width:50%}
            }
            &.grid-nine{
                width:33.33%;
            }
            &.double-grid{
                width:50%;
            }
        }
       
    }
    .only-one-img{margin-bottom: 10px;  display: flex;
        img{display: block; object-fit: cover;max-width:80%; max-height: 500px; display:block;}
    }
    .desc{
        display: flex;
        .flex-cont{flex:1; font-size: 14px; line-height: 20px; color: #999;}
        .view-total{display: flex; align-items: center; margin-right: 20px; font-size: 14px; line-height: 20px; color: #888;
            i{margin-right: 5px;
                
            }
        }
        .lit{
            display: flex; align-items: center; margin-right: 20px; font-size: 14px; line-height: 20px; color: #888;
            &.clicked{color: #e43a3a;}
            i{margin-right: 5px;
                
            }
            &.admire{cursor: pointer;
                i{font-size: 22px;}
            }
            &:hover{color: #e43a3a;}
            /* &.comment{
                i{transform: rotateY(180deg);}
            } */
        }
    }
    .show-style{
        display: flex;
        .g-lf{
            flex:1;overflow: hidden;
            display: flex; flex-direction: column;
            .middle-content{flex:1;}
        }
        .g-lr{width:25%; margin-left: 10px;}
    }
    .sign-img-border{
        ::v-deep{
            .el-image{border:1px solid #eee;  box-sizing: border-box;}
        }
    }
}
@media screen and (max-width:768px){
    .item{
        .desc{
            .lit{
                font-size: 12px;
                &.admire{cursor: pointer;
                    i{font-size: 20px;}
                }
            }
        }
    }
}

.video-warp{
    margin-bottom: 10px;
    video{width:80%; max-height: 480px;}
}
/* @media screen and (min-width:768px){
    .video-warp{
        background: #000;
        video{width:100%; max-height: 480px; margin: 0 auto;}
    }   
} */
</style>